module App.Messages

open Fable.Import.ReactVirtualized

type Msg =
    | FetchError of exn
    | FetchedDialects of obj []
    | SelectedDialect1Changed of string
    | SelectedDialect2Changed of string
    | FetchedWordlist1 of obj []
    | FetchedWordlist2 of obj []
    | WordFilter1Changed of string
    | WordFilter2Changed of string
    | DownloadWordlist1 of string
    | DownloadWordlist2 of string
    | DownloadedWordlist of string
    | SetWordTableSort1 of SortArg
    | SetWordTableSort2 of SortArg


// WEBPACK FOOTER //
// src/Messages.fs